declare namespace $ {

	type $mol_select__dictionary_easyreels_user_recorder_1 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['camera_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_easyreels_user_recorder_2 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['camera_device'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__enabled_easyreels_user_recorder_3 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['camera_select_enabled'] >
		,
		ReturnType< $mol_select['enabled'] >
	>
	type $mol_select__dictionary_easyreels_user_recorder_4 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['mic_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_easyreels_user_recorder_5 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['mic_device'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__enabled_easyreels_user_recorder_6 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['mic_select_enabled'] >
		,
		ReturnType< $mol_select['enabled'] >
	>
	type $mol_paragraph__title_easyreels_user_recorder_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_easyreels_user_recorder_8 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['warning_detail'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_easyreels_user_recorder_9 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['warning_problem'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_easyreels_user_recorder_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_easyreels_user_recorder_11 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['limit_detail'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_easyreels_user_recorder_12 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['error'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_easyreels_user_recorder_13 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['error_detail'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_video_player__controls_easyreels_user_recorder_14 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_video_player['controls'] >
	>
	type $mol_video_player__autoplay_easyreels_user_recorder_15 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_video_player['autoplay'] >
	>
	type $mol_video_player__inline_easyreels_user_recorder_16 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_video_player['inline'] >
	>
	type $mol_video_player__muted_easyreels_user_recorder_17 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_video_player['muted'] >
	>
	type $mol_video_player__stream_easyreels_user_recorder_18 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['stream'] >
		,
		ReturnType< $mol_video_player['stream'] >
	>
	type $mol_video_player__field_easyreels_user_recorder_19 = $mol_type_enforce<
		({ 
			'muted': boolean,
		})  & ReturnType< $mol_video_player['field'] >
		,
		ReturnType< $mol_video_player['field'] >
	>
	type $mol_video_player__style_easyreels_user_recorder_20 = $mol_type_enforce<
		({ 
			'transform': ReturnType< $easyreels_user_recorder['preview_transform'] >,
		})  & ReturnType< $mol_video_player['style'] >
		,
		ReturnType< $mol_video_player['style'] >
	>
	type $mol_video_player__event_easyreels_user_recorder_21 = $mol_type_enforce<
		({ 
			resize( next?: ReturnType< $easyreels_user_recorder['preview_resize'] > ): ReturnType< $easyreels_user_recorder['preview_resize'] >,
		})  & ReturnType< $mol_video_player['event'] >
		,
		ReturnType< $mol_video_player['event'] >
	>
	type $mol_view__sub_easyreels_user_recorder_22 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['top'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_easyreels_user_recorder_23 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['top_row'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_easyreels_user_recorder_24 = $mol_type_enforce<
		({ 
			'easyreels_user_recorder_badge_live': ReturnType< $easyreels_user_recorder['live'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_easyreels_user_recorder_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_easyreels_user_recorder_26 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['tool_list'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check__hint_easyreels_user_recorder_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check['hint'] >
	>
	type $mol_check__checked_easyreels_user_recorder_28 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['devices_open'] >
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_check__sub_easyreels_user_recorder_29 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_check['sub'] >
	>
	type $mol_view__sub_easyreels_user_recorder_30 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['devices_lines'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_labeler__title_easyreels_user_recorder_31 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_easyreels_user_recorder_32 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_labeler__title_easyreels_user_recorder_33 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_easyreels_user_recorder_34 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_paragraph__title_easyreels_user_recorder_35 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_minor__title_easyreels_user_recorder_36 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_easyreels_user_recorder_37 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['devices_close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_paragraph__title_easyreels_user_recorder_38 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['facing_hint'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_easyreels_user_recorder_39 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['warning_lines'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_easyreels_user_recorder_40 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_easyreels_user_recorder_41 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['status'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_easyreels_user_recorder_42 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['error_lines'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_easyreels_user_recorder_43 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['bottom'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_portion__portion_easyreels_user_recorder_44 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['level'] >
		,
		ReturnType< $mol_portion['portion'] >
	>
	type $mol_view__sub_easyreels_user_recorder_45 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['controls'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_easyreels_user_recorder_46 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['off_lines'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_easyreels_user_recorder_47 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['sheet_lines'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_easyreels_user_recorder_48 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['summary'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_easyreels_user_recorder_49 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['segment_links'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_link__uri_easyreels_user_recorder_50 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['segment_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__target_easyreels_user_recorder_51 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['target'] >
	>
	type $mol_link__title_easyreels_user_recorder_52 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['segment_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_view__sub_easyreels_user_recorder_53 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['links'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_easyreels_user_recorder_54 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['sheet_controls'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_major__title_easyreels_user_recorder_55 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_easyreels_user_recorder_56 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['ready_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_easyreels_user_recorder_57 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['preview_click'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__hint_easyreels_user_recorder_58 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_easyreels_user_recorder_59 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['switch_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_easyreels_user_recorder_60 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['switch_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_easyreels_user_recorder_61 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_major__title_easyreels_user_recorder_62 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_easyreels_user_recorder_63 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['ready_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_easyreels_user_recorder_64 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['start_click'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__title_easyreels_user_recorder_65 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_easyreels_user_recorder_66 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['stop_click'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__title_easyreels_user_recorder_67 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_easyreels_user_recorder_68 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['retry_click'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__title_easyreels_user_recorder_69 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_easyreels_user_recorder_70 = $mol_type_enforce<
		ReturnType< $easyreels_user_recorder['again_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $easyreels_user_recorder extends $mol_view {
		Theme( ): $mol_theme_auto
		mode( ): string
		layers( ): readonly(any)[]
		stream( ): any
		preview_transform( ): string
		preview_resize( next?: any ): any
		top( ): readonly(any)[]
		top_row( ): readonly(any)[]
		live( ): boolean
		badge( ): string
		tool_list( ): readonly(any)[]
		devices_open( next?: boolean ): boolean
		Settings_icon( ): $mol_icon_cog
		devices_lines( ): readonly(any)[]
		camera_options( ): Record<string, any>
		camera_device( next?: string ): string
		camera_select_enabled( ): boolean
		Camera_select( ): $mol_select
		mic_options( ): Record<string, any>
		mic_device( next?: string ): string
		mic_select_enabled( ): boolean
		Mic_select( ): $mol_select
		devices_close( next?: any ): any
		facing_hint( ): string
		Warning_title( ): $mol_paragraph
		warning_detail( ): string
		Warning_detail( ): $mol_paragraph
		warning_problem( ): string
		Warning_problem( ): $mol_paragraph
		warning_lines( ): readonly(any)[]
		Limit_title( ): $mol_paragraph
		limit_detail( ): string
		Limit_detail( ): $mol_paragraph
		status( ): string
		error( ): string
		Error_text( ): $mol_paragraph
		error_detail( ): string
		Error_detail( ): $mol_paragraph
		error_lines( ): readonly(any)[]
		bottom( ): readonly(any)[]
		level( ): number
		controls( ): readonly(any)[]
		off_lines( ): readonly(any)[]
		sheet_lines( ): readonly(any)[]
		summary( ): string
		segment_links( ): readonly(any)[]
		segment_uri( id: any): string
		segment_title( id: any): string
		sheet_controls( ): readonly(any)[]
		ready_enabled( ): boolean
		preview_click( next?: any ): any
		switch_enabled( ): boolean
		switch_click( next?: any ): any
		Switch_icon( ): $mol_icon_camera_flip
		start_click( next?: any ): any
		stop_click( next?: any ): any
		retry_click( next?: any ): any
		again_click( next?: any ): any
		plugins( ): readonly(any)[]
		tools( ): readonly(any)[]
		links( ): readonly(any)[]
		attr( ): ({ 
			'easyreels_user_recorder_mode': ReturnType< $easyreels_user_recorder['mode'] >,
		})  & ReturnType< $mol_view['attr'] >
		sub( ): ReturnType< $easyreels_user_recorder['layers'] >
		Preview( ): $mol_video_player
		Top( ): $mol_view
		Top_row( ): $mol_view
		Badge( ): $mol_view
		Tools( ): $mol_view
		Settings( ): $mol_check
		Devices( ): $mol_view
		Camera_field( ): $mol_labeler
		Mic_field( ): $mol_labeler
		Mic_note( ): $mol_paragraph
		Devices_close( ): $mol_button_minor
		Facing( ): $mol_paragraph
		Warning( ): $mol_view
		Limit( ): $mol_view
		Status( ): $mol_paragraph
		Error( ): $mol_view
		Bottom( ): $mol_view
		Meter( ): $mol_portion
		Controls( ): $mol_view
		Off( ): $mol_view
		Sheet( ): $mol_view
		Summary( ): $mol_paragraph
		Segments( ): $mol_list
		Segment_link( id: any): $mol_link
		Links( ): $mol_view
		Sheet_controls( ): $mol_view
		Preview_button( ): $mol_button_major
		Switch( ): $mol_button_minor
		Start( ): $mol_button_major
		Stop( ): $mol_button_major
		Retry( ): $mol_button_major
		Again( ): $mol_button_minor
	}
	
}

//# sourceMappingURL=recorder.view.tree.d.ts.map